import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconRocket = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.7883 18.3443C28.0023 13.1303 35.0899 10.9321 41.8868 11.7522C42.7068 18.5491 40.5087 25.6367 35.2947 30.8507C33.3382 32.8071 31.1197 34.3376 28.7531 35.4439C26.8517 36.3327 24.8536 36.9481 22.8179 37.2898L16.3491 30.821C16.6909 28.7854 17.3063 26.7873 18.1951 24.8859C19.3013 22.5192 20.8319 20.3007 22.7883 18.3443Z" stroke={color} strokeWidth="2"/>
            <path d="M23 18.4407H15.0639C14.7191 18.4407 14.3986 18.6183 14.2159 18.9107L10.3111 25.1583C9.9293 25.7692 10.2992 26.5712 11.0118 26.6773L16.5627 27.5041" stroke={color} strokeWidth="2"/>
            <path d="M35.0678 31L35.0678 38.7391C35.0678 39.0839 34.8902 39.4044 34.5978 39.5871L28.3502 43.4918C27.7393 43.8737 26.9373 43.5037 26.8311 42.7912L26.0044 37.2403" stroke={color} strokeWidth="2"/>
            <circle cx="35.3508" cy="18.3883" r="2.6824" transform="rotate(-45 35.3508 18.3883)" stroke={color} strokeWidth="2"/>
            <path d="M15.5715 33.4606L11.165 37.8672" stroke={color} strokeWidth="2"/>
            <path d="M20.5289 38.4179L16.1223 42.8245" stroke={color} strokeWidth="2"/>
            <path d="M17.925 35.8141L10.9146 42.8245" stroke={color} strokeWidth="2"/>
        </svg>
    </div>
);

export default IconRocket;
